import React, { useEffect, useState } from "react";
import editIcon from "../assets/edit.png";
import viewIcon from "../assets/View.svg";
import downloadIcon from "../assets/Download.svg";
import leftArrow from "../assets/left-arrow.png";
import rightArrow from "../assets/right-arrow.png";
import downArrow from "../assets/down-arrow.png";
import rightChevron from "../assets/right-chevron.png";
import leftChevron from "../assets/left-chevron.png";
import { getDocuments } from "../api/documentApi";
import { Spinner } from "react-bootstrap";

const tableData = [
  {
    label: "Federal W-4",
    jurisdiction: "FED",
    category: "Employee Tax Document",
    year: 2024,
    filedOn: "Feb 16, 2024",
  },
  {
    label: "Federal W-4",
    jurisdiction: "FED",
    category: "Employee Tax Document",
    year: 2025,
    filedOn: "Mar 21, 2025",
  },
  {
    label: "Federal W-4",
    jurisdiction: "FED",
    category: "Employee Tax Document",
    year: 2024,
    filedOn: "Feb 16, 2024",
  },
  {
    label: "Federal W-4",
    jurisdiction: "FED",
    category: "Employee Tax Document",
    year: 2025,
    filedOn: "Mar 21, 2025",
  },
];

const Documents = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [documents, setDocuments] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const companyId = "com_affa65d93030f0118b3d6045bdc7c627";
  const employeeId = "emp_55b194e8f530f0118b3d6045bdc7c627";

  const totalPages = Math.ceil(tableData.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const currentData = tableData.slice(startIndex, startIndex + rowsPerPage);

  const handlePrev = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const handleNext = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  const handleRowsChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
  };

  const fetchDocuments = async () => {
    try {
      setLoading(true);
      const response = await getDocuments(companyId, employeeId);
      if (Array.isArray(response.data)) {
        setDocuments(response.data);
      } else {
        console.error("Invalid data format from API", response);
      }
    } catch (error) {
      console.error("Failed to fetch documents:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, []);

  return (
    <div className="p-4">
      <h4 className="mb-2 main-title-for-all">Documents</h4>
      <p className="gray-text-for-content mb-4">
        Easily view, download, and manage your pay stubs, including detailed
        earnings, deductions, and tax information - all in one place.
      </p>

      <div className="mb-4 bg-white p-4 rounded">
        <div className="table-responsive table-border-layout">
          <table style={{ width: "100%" }}>
            <thead>
              <tr className="table-head">
                <th>Label</th>
                <th>Jurisdiction</th>
                <th>Category</th>
                <th>Year</th>
                <th>Filed On</th>
                <th>Action</th>
              </tr>
            </thead>
            {isLoading ? (
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: "320%",
                  marginTop: "20%",
                }}
              >
                <Spinner animation="border" />
              </div>
            ) : (
              <tbody className="gray-text-for-content">
                {documents?.map((doc, idx) => (
                  <tr key={idx}>
                    <td>{doc.label}</td>
                    <td>{doc.jurisdiction}</td>
                    <td>{doc.category}</td>
                    <td>{doc.year}</td>
                    <td>{formatDate(doc.filedOn)}</td>
                    <td>
                      <button className="border-0 p-0 mx-1">
                        <img src={downloadIcon} alt=" " />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
        </div>

        <div className="d-flex justify-content-end align-items-center mt-4">
          <div className="d-flex align-items-center">
            <span className="me-2 gray-text-for-content">Rows per page:</span>
            <select
              className="form-select gray-text-for-content border-0"
              style={{ width: "70px" }}
              value={rowsPerPage}
              onChange={handleRowsChange}
            >
              {[5, 10, 15, 20].map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>
          </div>
          <div className="d-flex align-items-center ">
            <span className="me-3 gray-text-for-content">
              {currentPage} - {totalPages === 0 ? 1 : totalPages}
            </span>

            <button
              className="me-2 border-0"
              style={{
                padding: "0px 5px",
                background: "#F8F8F8",
                borderRadius: "4px",
              }}
              onClick={() => setCurrentPage(1)}
              disabled={currentPage === 1}
            >
              <img src={leftChevron} style={{ width: "14px" }} alt="" />
            </button>

            <button
              className="border-0 me-2"
              onClick={handlePrev}
              style={{
                padding: "0px 5px",
                background: "#F8F8F8",
                borderRadius: "4px",
              }}
              disabled={currentPage === 1}
            >
              <img src={leftArrow} style={{ width: "14px" }} alt="" />
            </button>

            <button
              className="border-0 me-2"
              onClick={handleNext}
              style={{
                padding: "0px 5px",
                background: "#F8F8F8",
                borderRadius: "4px",
              }}
              disabled={currentPage === totalPages}
            >
              <img src={rightArrow} style={{ width: "14px" }} alt="" />
            </button>

            <button
              className="border-0"
              onClick={() => setCurrentPage(totalPages)}
              style={{
                padding: "0px 5px",
                background: "#F8F8F8",
                borderRadius: "4px",
              }}
              disabled={currentPage === totalPages}
            >
              <img src={rightChevron} style={{ width: "14px" }} alt="" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Documents;
